<template>
  <button
    type="button"
    :disabled="user.loading || disabled"
    @click="Step"
    :class="[
      'v-btn v-btn--contained v-btn--rounded theme--light v-size--large mt-10 ' + label.alias, (user && user.loading) || disabled ? 'disabled' : 'primary'
    ]"
    :style="['color: #ffffff', (user && user.loading) || disabled ? {'cursor': 'not-allowed'} : {}]"
  >
    {{ label.text }}
  </button>
</template>

<script>
import Vue from 'vue';
import helpers from '@/settings/helpers';
import { createNamespacedHelpers } from 'vuex';
import localizationTexts from '@/localization/texts.json';
const { mapGetters } = createNamespacedHelpers('user');

export default Vue.extend({
  name: 'ProgressButton',
  props: {
    step: Object,
    label: Object
  },
  data() {
    return {
      disabled: false,
      dataLayerData: { event: 'easybooking-click', eventCategory: '', eventAction: '' }
    };
  },
  components: {},
  methods: {
    CheckHome(mode) {
      let check = false;
      if (
        this.user.errors.registration == '' &&
        this.user.car.registrationplate !== undefined &&
        this.user.kilometers > 0 &&
        (this.user.registrationplateerrormessagekey === '' ||
          this.user.registrationplateerrormessagekey === 'cdkMmvIdentification' ||
          this.user.registrationplateerrormessagekey === 'datamannMmvIdentification')
      ) {
        check = true;
      }

      if (mode) {
        if (check) {
          this.$store.dispatch('user/initStep', 1);
        } else {
          this.$store.dispatch('user/initStep', 0);
        }
      }

      return check;
    },
    CheckService(mode) {
      let check = this.CheckHome();
      if (check === true) {
        check = false;
        if (
          this.user.car.registrationplate !== undefined &&
          this.user.kilometers > 0 &&
          this.user.department.departmentid !== undefined &&
          this.user.services.length > 0 &&
          this.user.car.makecode !== null
        ) {
          check = true;
        }

        if (mode) {
          if (check) {
            this.$store.dispatch('user/initStep', 2);
          } else {
            this.$store.dispatch('user/initStep', 1);
          }
        }
      }

      return check;
    },
    CheckAppointment(mode) {
      let check = this.CheckService();
      if (check === true) {
        check = false;

        if (
          this.user.car.registrationplate !== undefined &&
          this.user.kilometers > 0 &&
          this.user.department.departmentid !== undefined &&
          this.user.services.length > 0 &&
          this.user.datetime.option &&
          this.user.datetime.date &&
          this.user.datetime.arrival
        ) {
          check = true;

          if (this.user.config.parameters.parameters.pickuptimeoverwrite === undefined) {
            check = check && this.user.datetime.arrival !== '';
            if (
              this.user.datetime.option.alias === '1000' ||
              this.user.datetime.option.alias === '0' ||
              this.user.datetime.option.alias === '2' ||
              this.user.datetime.option.alias === '3'
            ) {
              check = check && this.user.datetime.pickup !== '';
            }
          } else {
            check = check && this.user.datetime.arrival !== '';
          }
        }

        if (mode) {
          if (check) {
            this.$store.dispatch('user/initStep', 3);
          } else {
            this.$store.dispatch('user/initStep', 2);
          }
        }
      }

      return check;
    },
    CheckCustomer(mode) {
      let check = this.CheckAppointment();
      if (check === true) {
        check = false;
        if (
          this.user.car.registrationplate !== undefined &&
          this.user.kilometers > 0 &&
          this.user.department.departmentid !== undefined &&
          this.user.services.length > 0 &&
          this.user.datetime.option &&
          this.user.datetime.date !== '' &&
          this.user.datetime.arrival !== '' &&
          this.user.info.firstname !== '' &&
          this.user.info.lastname !== '' &&
          this.user.info.address !== '' &&
          this.user.info.zipcode !== '' &&
          this.user.info.city !== '' &&
          this.user.info.email !== '' &&
          this.user.info.phone !== '' &&
          this.user.info.accepted === true
        ) {
          check = true;
        }

        if (mode) {
          if (check) {
            this.$store.dispatch('user/initStep', 4);
          } else {
            this.$store.dispatch('user/initStep', 3);
          }
        }
      }

      return check;
    },
    CheckConfirmation(mode) {
      let check = this.CheckCustomer();
      if (check === true) {
        check = false;

        if (
          this.user.car.registrationplate !== undefined &&
          this.user.kilometers > 0 &&
          this.user.department.departmentid !== undefined &&
          this.user.services.length > 0 &&
          this.user.datetime.option &&
          this.user.datetime.date !== '' &&
          this.user.datetime.arrival !== '' &&
          this.user.info.firstname !== '' &&
          this.user.info.lastname !== '' &&
          this.user.info.address !== '' &&
          this.user.info.zipcode !== '' &&
          this.user.info.city !== '' &&
          this.user.info.email !== '' &&
          this.user.info.phone !== '' &&
          this.user.info.accepted === true
        ) {
          check = true;
        }

        if (mode) {
          if (check) {
            this.$store.dispatch('user/initStep', 5);
          } else {
            this.$store.dispatch('user/initStep', 4);
          }
        }
      }

      return check;
    },
    Step() {
      let currentStep = this.step.number;
      const owner = this;
      this.setDataLayerData();
      switch (currentStep) {
        case 4:
          if (this.CheckConfirmation(true)) {
            let test = this.user.config.parameters.parameters.test;
            this.$store.dispatch('user/initValidation', false);
            this.$store.dispatch('user/initLoading', true);
            helpers.sendGTM(owner.dataLayerData, this.user.config.host);
            // overwriting arrival and pickup if dropofftimes have been set in widget markup
            let confirmationPayload = {
              endpoint: this.user.config.parameters.api + '/maintenance/CreateServiceBooking',
              data: {
                forwarding: this.user.specialProperties.forwarding.endpoint,
                marketingConsent: this.user.specialProperties.forwarding.marketingConsent,
                consent: this.user.info.accepted,
                token: this.user.token,
                traceid: this.user.guid,
                rooftopid: this.user.selectedRooftopid,
                culture: this.user.config.parameters.parameters.culture,
                firstname: this.user.info.firstname,
                emailaddress: this.user.info.email,
                customerid: this.user.info.email,
                surname: this.user.info.lastname,
                vehicleregistrationno: this.user.registrationplate,
                chassisno: this.user.car.chassisno,
                lastregistereddate: this.user.car.lastregistereddate,
                vehmakecode: this.user.car.makecode,
                vehmakename: this.user.car.maketext,
                vehmodelcode: this.user.car.modelcode,
                vehmodelname: this.user.car.modeltext,
                vehvariantcode: this.user.car.variantcode,
                actualmileage: this.user.kilometers,
                vin: this.user.car.vin,
                mobiletelno: this.user.info.phone,
                address1: this.user.info.address,
                postalcode: this.user.info.zipcode,
                city: this.user.info.city,
                jobs: this.user.services,
                singlehourterm: localizationTexts[this.user.config.language].general.time.hour,
                pluralhourterm: localizationTexts[this.user.config.language].general.time.hours,
                singleminuteterm: localizationTexts[this.user.config.language].general.time.minute,
                pluralminuteterm: localizationTexts[this.user.config.language].general.time.minutes,
                comment: '',
                servicestime: this.user.config.parameters.parameters.servicestime,
                servicesprice: this.user.config.parameters.parameters.servicesprice,
                currency: localizationTexts[this.user.config.language].general.words.currency,
                servicepriceprefix: localizationTexts[this.user.config.language].general.words.from,
                jobdate: this.user.datetime.date,
                advisordropofftimecode: this.user.datetime.arrival.text,
                advisordropofftimecodetext: '',
                advisorpickuptimecode: this.user.datetime.pickup.text,
                advisorpickuptimecodetext: '',
                advisorpickuptimecodetextoverride: '',
                option: this.user.datetime.option,
                emailsubject: localizationTexts[this.user.config.language].pageAccept.emailSubject,
                genericservicejobdescription: localizationTexts[this.user.config.language].pageServices.genericServiceJobDescription,
                genericserviceplaceholdertext: localizationTexts[this.user.config.language].pageServices.genericServicePlaceholderText,
                colorprimary: this.user.config.parameters.parameters.colorprimary,
                istest: test,
                rentlognotificationtext: localizationTexts[this.user.config.language].pageAccept.rentLogNotificationText,
                translatedpickuptimetext: localizationTexts[this.user.config.language].pageAccept.pickup,
                expectedservicetimetext: localizationTexts[this.user.config.language].pageAccept.expectedServiceTime,
                disableemailconfirmation: this.user.config.parameters.parameters.disableemailconfirmation,
                referrer: this.user.config.parameters.parameters.referrer
              }
            };

            if(
              this.user.config.parameters.parameters.timesreplace ||
              this.user.config.parameters.parameters.timesreplacerental ||
              this.user.config.parameters.parameters.timesreplacewaiting ||
              this.user.config.parameters.parameters.timesreplacerentlog)
              {
                confirmationPayload.data.comment = localizationTexts[this.user.config.language].pageAccept.customDropOffComment;
              }

            if (this.user.config.parameters.parameters.pickuptimeoverwrite) {
              confirmationPayload.data.advisorpickuptimecodetextoverride = this.user.config.parameters.parameters.pickuptimeoverwrite;
            }
            
            this.$store.dispatch('appointment/confirmAppointment', confirmationPayload).then(() => {
              const encryptData = this.$store.getters['appointment/appointment'].encryptData;
              this.$store.dispatch('user/sendForwardingBookingInfo', encryptData);
              this.$store.dispatch('user/initLoading', false);
              const customConfirmationTarget = this.user.config.parameters.parameters.customconfirmationtarget;
              if(customConfirmationTarget) {
                helpers.sendRedirect(this.user.config.host, customConfirmationTarget);
              } else {
                this.$router.push({ name: 'End' });
              }
            });
          } else {
            this.$store.dispatch('user/initValidation', true);
          }
          break;
        case 3:
          if (this.CheckCustomer(true)) {
            this.$store.dispatch('user/initValidation', false);
            helpers.sendGTM(owner.dataLayerData, this.user.config.host);
            this.$router.push({ name: 'Confirmation' });
          } else {
            this.$store.dispatch('user/initValidation', true);
          }
          break;
        case 2:
          if (this.CheckAppointment(true)) {
            this.$store.dispatch('user/initValidation', false);
            helpers.sendGTM(owner.dataLayerData, this.user.config.host);
            this.$router.push({ name: 'Customer' });
          } else {
            this.$store.dispatch('user/initValidation', true);
          }
          break;
        case 1:
          if (this.CheckService(true)) {
            this.$store.dispatch('user/initValidation', false);
            helpers.sendGTM(owner.dataLayerData, this.user.config.host);
            this.$router.push({ name: 'Appointment' });
          } else {
            this.$store.dispatch('user/initValidation', true);
          }
          break;
        case 0:
          if (this.CheckHome(true)) {
            this.$store.dispatch('user/initValidation', false);
            helpers.sendGTM(owner.dataLayerData, this.user.config.host);
            this.$router.push({ name: 'Service' });
          } else {
            this.$store.dispatch('user/initValidation', true);
          }
          break;
        default:
          this.$store.dispatch('user/initValidation', false);
          this.$store.dispatch('user/initStep', 0);
          helpers.sendGTM(owner.dataLayerData, this.user.config.host);
          this.$router.push({ name: 'Home' });
      }
    },
    CheckButtonDisabled() {
      let currentStep = this.step.number;
      switch (currentStep) {
        case 4:
          this.disabled = !this.CheckConfirmation(false);
          break;
        case 3:
          this.disabled = !this.CheckCustomer(false);
          break;
        case 2:
          this.disabled = !this.CheckAppointment(false);
          break;
        case 1:
          this.disabled = !this.CheckService(false);
          break;
        case 0:
          this.disabled = !this.CheckHome(false);
          break;
        default:
      }
    },
    setDataLayerData() {
      this.dataLayerData.eventCategory = this.label.page;
      this.dataLayerData.eventAction = this.label.action;
    }
  },
  mounted() {
    this.CheckButtonDisabled();
  },
  updated() {
    this.CheckButtonDisabled();
  },
  computed: {
    ...mapGetters(['user'])
  }
});
</script>

<style scoped lang="scss">
.v-btn {
  width: 135px;
}

@media (min-width: 600px) {
  .v-btn {
    width: 220px;
  }
}
</style>

<i18n src="../localization/texts.json"></i18n>
